<div class="register-container">
  <auth-header (selectedLanguageGuid)="onSelectedLanguageGuid($event)"></auth-header>
  <div class="register-form">
    @if (registerationStep === RegisterationSteps.PHONE) {
      <div class="header">
        <button
          pButton
          (click)="backButton()"
          class="back-button"
          severity="secondary"
          icon="ph ph-caret-left"
          aria-label="Back"></button>
        <dk-progress-bar [progressValues]="progressFor(RegisterationSteps.PHONE)"></dk-progress-bar>
        <span class="title-text">{{ 'doktar_app.auth.register.title' | translate }}</span>
        <span class="subtitle-text">
          {{ 'doktar_app.auth.register.phone_number.title' | translate }}
        </span>
      </div>

      <auth-register-phone (steperChange)="onSteperChange($event)"></auth-register-phone>
      <div class="register-buttons">
        <p-button class="already-in-button" (onClick)="goToLogin()" variant="text">
          <span
            >{{ 'doktar_app.auth.register.login_subtitle' | translate }}
            <b>{{ 'doktar_app.auth.login.page_title' | translate }}</b>
          </span>
        </p-button>
      </div>
      <div class="sso-container">
        <span class="sso-info-text">{{ 'doktar_app.auth.register.sso_information' | translate }}</span>
        <div class="sso-button-container">
          <p-button severity="secondary" aria-label="Apple SSO" (click)="onSSOButtonClick('apple')">
            <ng-template pTemplate="icon">
              <dk-apple-icon></dk-apple-icon>
            </ng-template>
          </p-button>
          <p-button severity="secondary" aria-label="Google SSO" (click)="onSSOButtonClick('google')">
            <ng-template pTemplate="icon">
              <dk-google-icon></dk-google-icon>
            </ng-template>
          </p-button>
          @if (false) {
            <p-button severity="secondary" aria-label="MS SSO" (click)="onSSOButtonClick('ms')">
              <ng-template pTemplate="icon">
                <dk-microsoft-icon></dk-microsoft-icon>
              </ng-template>
            </p-button>
            <p-button severity="secondary" aria-label="FB SSO" (click)="onSSOButtonClick('facebook')">
              <ng-template pTemplate="icon">
                <dk-facebook-icon></dk-facebook-icon>
              </ng-template>
            </p-button>
          }
        </div>
      </div>
    } @else if (registerationStep === RegisterationSteps.EMAIL) {
      <div class="header">
        <button
          pButton
          (click)="backFromEmail()"
          class="back-button"
          severity="secondary"
          icon="ph ph-caret-left"
          aria-label="Back"></button>
        <dk-progress-bar [progressValues]="progressFor(RegisterationSteps.EMAIL)"></dk-progress-bar>
        <span class="title-text">{{ 'doktar_app.auth.register.title' | translate }}</span>
        <span class="subtitle-text">
          {{ 'doktar_app.auth.register.subtitle' | translate }}
        </span>
      </div>

      <span class="email-input-label">
        {{ 'doktar_app.auth.login.email_label' | translate }}
      </span>

      <input
        pInputText
        class="email-input-text"
        type="email"
        name="email"
        (change)="onEmailChange($event)"
        [(ngModel)]="registerModal.email"
        #emailInput="ngModel"
        [placeholder]="'doktar_app.common.email_placeholder' | translate"
        [email]="true" />
      <div class="register-buttons">
        @if (somethingWentWrong) {
          <div class="error-container">
            <span class="error-text">
              {{ errorMessage | translate }}
            </span>
          </div>
        }
        <dk-button
          class="register-button"
          [size]="'xlarge'"
          [label]="'doktar_app.auth.register.register' | translate"
          [disabled]="!registerModal.email || emailInput.invalid"
          [loading]="registering"
          (onClick)="goToRegister()"></dk-button>
      </div>
    } @else if (registerationStep === RegisterationSteps.VERIFY_EMAIL_OTP) {
      <div @stepTransition>
        <auth-register-verify-otp
          [otpChannel]="'email'"
          [verifyOtpInfo]="registerModal.email"
          [progressValues]="progressFor(RegisterationSteps.VERIFY_EMAIL_OTP)"
          (steperChange)="onSteperChange($event)"></auth-register-verify-otp>
      </div>
    } @else if (registerationStep === RegisterationSteps.PASSWORD) {
      <div @stepTransition>
        <auth-register-pwd (steperChange)="onSteperChange($event)"></auth-register-pwd>
      </div>
    } @else if (registerationStep === RegisterationSteps.VERIFY_PHONE_OTP) {
      <div @stepTransition>
        <auth-register-verify-otp
          [otpChannel]="'phone'"
          [verifyOtpInfo]="phoneOtpTarget"
          [progressValues]="progressFor(RegisterationSteps.VERIFY_PHONE_OTP)"
          (steperChange)="onSteperChange($event)"></auth-register-verify-otp>
      </div>
    } @else if (registerationStep === RegisterationSteps.ABOUT) {
      <div @stepTransition>
        <auth-register-about (steperChange)="onSteperChange($event)"></auth-register-about>
      </div>
    } @else if (registerationStep === RegisterationSteps.PROFESSION) {
      <div @stepTransition>
        <auth-register-profession
          [registrationPending]="registeringAfterProfession"
          [registrationError]="professionRegistrationError"
          (registrationRequested)="registerAfterProfession()"
          (professionSelected)="onProfessionSelected($event)"></auth-register-profession>
      </div>
    }
  </div>
</div>
